import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  List,
  ListItem,
  /* ListItemSecondaryAction, */
  Button,
  Accordion,
  AccordionSummary,
  Typography,
  ListItemText,
  /* OutlinedInput, */
  AccordionDetails,
  /*  MenuItem,
   FormControl,
   Select, */
  withStyles,
  TextField,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import withWidth from "@material-ui/core/withWidth";
import Bordered from "../../../shared/components/Bordered";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import { Form, Field } from 'react-final-form'
import api from './../../../shared/functions/api/';
import HelpIcon from "../../../shared/components/HelpIcon";

const styles = theme => ({
  numberInput: {
    width: 110
  },
  numberInputInput: {
    padding: "9px 34px 9px 14.5px"
  },
  dBlock: { display: "block" },
  listItemLeftPadding: {
    paddingRight: theme.spacing(3)
  },
  listItemLeftRightPadding: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  accordionDetails: {
    paddintTop: theme.spacing(0),
    justifyContent: "flex-end"
  }
});
/* const inputOptions = ["None", "Slow", "Normal", "Fast"]; */

export const valuesMapAvailability = {
  '1': 'Immediately', 
  '2': '3-5 days', 
  '3': 'On Demand',
}

class DiamondsAvailabilitySettings extends Component {
  state = {
    expanded: false,
    data: false,
    loading: false,
    defaultValues: {
      diamond_available_now: valuesMapAvailability['1'],
      diamond_available_later: valuesMapAvailability['2'],
      diamond_available_on_demand: valuesMapAvailability['3'],
    }
  };

  /* handleChange = event => {
    const { name, value } = event.target;
    if (name === "option6") {
      if (value > 7500 || value < 1000) {
        return;
      }
    }
    this.setState({ [name]: value });
  }; */

  componentDidMount() {
    this.loaddata();
  }

  async loaddata() {
    const res = await api.get('/configs?fields=type&filter=diamond_available');
    this.setState({ data: res.data.docs[0] || { fields: this.state.defaultValues } })
  }

  onSubmit = async values => {
    const { pushMessageToSnackbar } = this.props;
    const { data } = this.state;
    this.setState({ loading: true });

    try {
      const settings = {
        type: 'diamond_available',
        fields: {
          ...values
        }
      };

      let res = false;
      if (data._id) {
        res = await api.patch(`/configs/${data._id}`, settings);
      } else {
        res = await api.post('/configs', settings);
      }

      this.setState({ data: res.data }, () => console.log(this.state.data));

      pushMessageToSnackbar({
        text: "Your settings have been saved"
      });
      this.setState({ loading: false, expanded: false });
    } catch (err) {
      console.log(JSON.stringify(err, 0, 2));
      /* 
      pushMessageToSnackbar({
        isErrorMessage: true,
        text: err.message + ': ' + (err.response.data.errors.msg.map(error => `${error.msg}: ${error.param}`).join(', '))
      }); */
      this.setState({ loading: false });
    }

  };

  render() {
    const {
      loading,
      data,
    } = this.state;

    const {
      diamond_available_now,
      diamond_available_later,
      diamond_available_on_demand,
    } = data;

    const { classes } = this.props;

    const inputs = [
      {
        state: diamond_available_now,
        label: "Available Now",
        fieldName: "diamond_available_now"
      },
      {
        state: diamond_available_later,
        label: "Available Later",
        fieldName: "diamond_available_later"
      },
      {
        state: diamond_available_on_demand,
        label: "Available On Demand",
        fieldName: "diamond_available_on_demand"
      },
    ];
    return (
      <Accordion expanded={this.state.expanded} onChange={(e, expanded) => this.setState({expanded})}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Diamonds Availability <HelpIcon title={'Diamonds Availability Settings'} /></Typography>
        </AccordionSummary>
        <Form
          onSubmit={this.onSubmit}
          validate={values => {
            const errors = {}
            /* if (!values.existing) {
              errors.existing = 'Required'
            } */

            /**
           * Handle Material UI components better together with React Final Form
           * https://www.npmjs.com/package/mui-rff
           */

            /* if (!values.password) {
              errors.password = 'Required'
            }
            if (!values.confirm) {
              errors.confirm = 'Required'
            } else if (values.confirm !== values.password) {
              errors.confirm = 'Must match'
            } */
            return errors
          }}
          initialValues={{
            ...this.state.data.fields
          }}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit}>
              <AccordionDetails className={classes.dBlock}>
                <List disablePadding>
                  <Bordered disableVerticalPadding disableBorderRadius>
                    {inputs.map((element, index) => (
                      <ListItem
                        className="listItemLeftRightPadding"
                        disableGutters
                        divider
                        key={index}
                      >
                        <ListItemText>
                          {/* <Typography variant="body2">{element.label}</Typography> */}
                          <Field
                            name={element.fieldName}
                            render={({ input, meta }) => (
                              <TextField
                                label={element.label}
                                placeholder={`Enter ${element.label} URL...`}
                                helperText={meta.error && meta.touched && meta.error}
                                variant="outlined"
                                fullWidth
                                {...input}
                              />
                            )}
                          />
                        </ListItemText>

                      </ListItem>
                    ))}
                    {
                      /* <ListItem className="listItemLeftPadding" disableGutters divider>
                        <ListItemText>
                          <Typography variant="body2">Option 5</Typography>
                        </ListItemText>
                        <FormControl variant="outlined">
                          <ListItemSecondaryAction
                            className={classes.ListItemSecondaryAction}
                          >
                            <Select
                              value={option5}
                              onChange={this.handleChange}
                              input={
                                <OutlinedInput
                                  name="option5"
                                  labelWidth={0}
                                  className={classes.numberInput}
                                  classes={{ input: classes.numberInputInput }}
                                />
                              }
                            >
                              {[
                                "Always",
                                "6 Hours",
                                "12 Hours",
                                "1 Day",
                                "2 Days",
                                "3 Days",
                                "1 Week"
                              ].map(element => (
                                <MenuItem value={element} key={element}>
                                  {element}
                                </MenuItem>
                              ))}
                            </Select>
                          </ListItemSecondaryAction>
                        </FormControl>
                      </ListItem>
                      <ListItem className="listItemLeftPadding" disableGutters>
                        <ListItemText>
                          <Typography variant="body2">Option 6</Typography>
                        </ListItemText>
                        <FormControl variant="outlined">
                          <ListItemSecondaryAction
                            className={classes.ListItemSecondaryAction}
                          >
                            <OutlinedInput
                              labelWidth={0}
                              name="option6"
                              value={option6}
                              type="number"
                              onChange={this.handleChange}
                              className={classes.numberInput}
                              classes={{ input: classes.numberInputInput }}
                              inputProps={{ step: 20 }}
                            />
                          </ListItemSecondaryAction>
                        </FormControl>
                      </ListItem> */
                    }
                  </Bordered>
                </List>
              </AccordionDetails>
              <AccordionDetails className={classes.accordionDetails}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={loading}
                  type="submit"
                >
                  Save {loading && <ButtonCircularProgress />}
                </Button>
              </AccordionDetails>
            </form>
          )}
        />
      </Accordion>
    );
  }
}

DiamondsAvailabilitySettings.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  pushMessageToSnackbar: PropTypes.func
};

export default withWidth()(withStyles(styles, { withTheme: true })(DiamondsAvailabilitySettings));
